const getters = {
  courseId: state => state.app.courseId,
  testId: state => state.app.testId,
  shareCourseId: state => state.app.shareCourseId,
  id: state => state.user.id,
  userid: state => state.user.userinfo.userid,
  userinfo: state => state.user.userinfo,
  fromL: state => state.user.fromL,
  token: state => state.user.token,
  appSign: state => state.user.appSign,
  userinfo2: state => state.user.userinfo2
}
export default getters
